import { Component, Input } from "@angular/core";
import { NbButtonModule, NbCardModule, NbDialogRef } from "@nebular/theme";

@Component({
  selector: "ngx-delete-confirm",
  templateUrl: "./delete-confirm.component.html",
  styleUrls: ["./delete-confirm.component.scss"],
  imports: [NbCardModule, NbButtonModule],
})
export class DeleteConfirmComponent {
  @Input() title: string = "Confirm";
  @Input() message: string = "Are you sure you want to delete this item?";
  @Input() confirmButtonText: string = "Confirm";
  @Input() cancelButtonText: string = "Cancel";

  constructor(protected ref: NbDialogRef<boolean>) {}

  cancel() {
    this.ref.close(false);
  }

  confirm() {
    this.ref.close(true);
  }
}
